export { Table as default } from './Table'
export { default as Details } from './Details'
